/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_EzInputs */

const en_us2_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~8 kg`)
};

const pt_br2_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~8 kg`)
};

const es_419_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~8 kg`)
};

const pt_pt2_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~8 kg`)
};

const fr_fr2_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~8 kg`)
};

const de_de2_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SZ ~8 kg`)
};

const it_it2_workout_logging_bar_ez = /** @type {(inputs: Workout_Logging_Bar_EzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EZ ~8 kg`)
};

/**
* | output |
* | --- |
* | "EZ ~8 kg" |
*
* @param {Workout_Logging_Bar_EzInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_ez = /** @type {((inputs?: Workout_Logging_Bar_EzInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_EzInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_ez(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_ez(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_ez(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_ez(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_ez(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_ez(inputs)
	return en_us2_workout_logging_bar_ez(inputs)
});
export { workout_logging_bar_ez as "workout-logging.bar_ez" }